import EnhancedTable from '@sophocles/components/EnhancedTable/EnhancedTable';
import EnhancedTableHead from '@sophocles/components/EnhancedTable/EnhancedTableHead';
import EnhancedTableToolbar from '@sophocles/components/EnhancedTable/EnhancedTableToolbar';
export default EnhancedTable;

export { EnhancedTableHead, EnhancedTableToolbar };
